import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <polygon points="12.5,0 9.55,9.55 0,9.55 7.72,15.45 4.77,25 12.5,19.1 20.23,25 17.27,15.45 25,9.55 15.45,9.55 " />
    </g>
  </svg>
);
